import type { JSX } from 'react';
import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import PageHeader from '@/components/PageHeader';
import NoteForm from '@/forms/NoteForm';
import Container from '@/ui/components/Container';

const NewNote = (): JSX.Element | null => {
  const [queryParams] = useSearchParams();
  const objectId = queryParams.get('objectId');
  const returnTo = queryParams.get('returnTo');
  const contentTypeName = queryParams.get('contentTypeName');

  const navigate = useNavigate();

  const handleSuccessCallback = () => {
    if (returnTo) {
      navigate(returnTo);
    }
  };

  if (!objectId) {
    return <Container type="page">No object ID provided</Container>;
  }

  if (!contentTypeName) {
    return <Container type="page">No content type name provided</Container>;
  }

  return (
    <Container type="page">
      <PageHeader headingText="New Note" />

      <NoteForm
        objectId={objectId}
        contentTypeName={contentTypeName}
        successCallback={handleSuccessCallback}
      />
    </Container>
  );
};
export default React.memo(NewNote);
